var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-order"
  }, [_c('div', {
    staticClass: "flex items-center bg-neutral-700 py-10 px-40 stepper relative mdmax:px-4 mdmax:text-center mdmax:gap-2 mdmax:-mx-4 mdmax:py-6 mdmax:items-stretch"
  }, [_c('div', {
    staticClass: "flex-1 py-2 px-6 rounded bg-primary-100 mdmax:pl-3 mdmax:pr-3",
    class: {
      arrow: !_vm.isMobile
    }
  }, [_c('p', {
    staticClass: "text-sm font-medium "
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.title')))]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.desc')))])]), _c('div', {
    staticClass: "flex-1 py-2 pl-10 pr-6 bg-white rounded mdmax:pl-3 mdmax:pr-3",
    class: {
      arrow: !_vm.isMobile
    }
  }, [_c('p', {
    staticClass: "text-sm font-medium "
  }, [_vm._v("Logistik & Pembayaran")]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v("Pilih logistik dan bayar")])])]), _c('div', {
    staticClass: "flex items-stretch bg-white shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "w-1/2 shadow-border-r p-6 mdmax:px-4 mdmax:shadow-none mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold mb-4"
  }, [_vm._v("Informasi Pengirim")]), _c('div', {
    staticClass: "bg-white border border-neutral-200 rounded-xl shadow-sm overflow-hidden mb-6"
  }, [_c('div', {
    staticClass: "p-5 cursor-pointer hover:bg-neutral-50 transition-colors",
    on: {
      "click": function click($event) {
        return _vm.openAddressFormModal('sender');
      }
    }
  }, [_c('div', {
    staticClass: "flex items-start gap-4"
  }, [_c('div', {
    staticClass: "mt-1"
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "#2D3748"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
    }
  })])]), _c('div', {
    staticClass: "flex-1"
  }, [_vm.selectedAddress ? _c('div', [_c('p', {
    staticClass: "font-bold text-neutral-800 text-lg mb-1 flex items-center gap-2"
  }, [_vm._v(" " + _vm._s(_vm.selectedAddress.sender_name) + " "), _c('span', {
    staticClass: "text-sm text-neutral-500 font-normal"
  }, [_vm._v(_vm._s(_vm.selectedAddress.sender_phone || _vm.selectedAddress.phone))])]), _c('p', {
    staticClass: "text-sm text-neutral-600 mb-1 leading-relaxed"
  }, [_vm._v(_vm._s(_vm.selectedAddress.address))]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v(_vm._s(_vm.selectedAddress.area ? _vm.selectedAddress.area.village + ', ' + _vm.selectedAddress.area.area_display : ''))])]) : _c('div', [_c('p', {
    staticClass: "font-bold text-neutral-800 text-lg mb-1"
  }, [_vm._v("Pengirim")]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Pilih atau isi informasi pengirim")])])])])])]), _c('p', {
    staticClass: "font-bold mb-4"
  }, [_vm._v("Informasi Penerima")]), _c('div', {
    staticClass: "bg-white border border-neutral-200 rounded-xl shadow-sm overflow-hidden mb-6"
  }, [_c('div', {
    staticClass: "p-5 cursor-pointer hover:bg-neutral-50 transition-colors",
    on: {
      "click": function click($event) {
        return _vm.openAddressFormModal('receiver');
      }
    }
  }, [_c('div', {
    staticClass: "flex items-start gap-4"
  }, [_c('div', {
    staticClass: "mt-1"
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
      "stroke": "#2D3748",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z",
      "stroke": "#2D3748",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _c('div', {
    staticClass: "flex-1"
  }, [_vm.receiverName && _vm.receiverPhoneNumber && _vm.payloads.destination_city ? _c('div', [_c('p', {
    staticClass: "font-bold text-neutral-800 text-lg mb-1 flex items-center gap-2"
  }, [_vm._v(" " + _vm._s(_vm.receiverName) + " "), _c('span', {
    staticClass: "text-sm text-neutral-500 font-normal"
  }, [_vm._v(_vm._s(_vm.receiverPhoneNumber))])]), _vm.addressDetail ? _c('p', {
    staticClass: "text-sm text-neutral-600 mb-1 leading-relaxed"
  }, [_vm._v(_vm._s(_vm.addressDetail))]) : _vm._e(), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v(_vm._s(_vm.payloads.destination_city ? _vm.payloads.destination_city.village + ', ' + _vm.payloads.destination_city.area_display : ''))])]) : _c('div', [_c('p', {
    staticClass: "font-bold text-neutral-800 text-lg mb-1"
  }, [_vm._v("Penerima")]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Pilih atau isi informasi penerima")])])])])])])]), _c('div', {
    staticClass: "w-1/2 p-6 mdmax:px-4 mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold mb-4"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.serviceType')))]), _vm.isScheduleOrder ? _c('div', {
    staticClass: "mb-6 flex items-center gap-4"
  }, [_c('div', {
    staticClass: "w-1/2"
  }, [_c('TextField', {
    attrs: {
      "type": "date",
      "min": _vm.today,
      "label": _vm.$t('order.createOrder.stepOne.pickupDate')
    },
    model: {
      value: _vm.scheduleDate,
      callback: function callback($$v) {
        _vm.scheduleDate = $$v;
      },
      expression: "scheduleDate"
    }
  })], 1), _c('div', {
    staticClass: "custom-select w-1/2"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.pickupTime')))]), _c('v-select', {
    attrs: {
      "options": _vm.pickupSlotTime,
      "placeholder": _vm.$t('order.createOrder.stepOne.pickupTimePlaceholder'),
      "label": "display"
    },
    model: {
      value: _vm.scheduleTime,
      callback: function callback($$v) {
        _vm.scheduleTime = $$v;
      },
      expression: "scheduleTime"
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "mb-6 custom-select"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.packageType')))]), _c('v-select', {
    attrs: {
      "options": _vm.goodsCategories,
      "placeholder": _vm.$t('order.createOrder.stepOne.packageTypePlaceholder'),
      "reduce": function reduce(selectedPackage) {
        return selectedPackage.code;
      },
      "label": "name"
    },
    model: {
      value: _vm.selectedPackage,
      callback: function callback($$v) {
        _vm.selectedPackage = $$v;
      },
      expression: "selectedPackage"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-4 inline-block"
  }, [_vm._v("Ukuran dan Dimensi Paket")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.modal.weight')) + " "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "withIcon": "",
      "placeholder": _vm.$t('order.createOrder.stepOne.modal.weightPlaceholder')
    },
    on: {
      "input": _vm.handleWeightInput
    },
    model: {
      value: _vm.custom.weight,
      callback: function callback($$v) {
        _vm.$set(_vm.custom, "weight", $$v);
      },
      expression: "custom.weight"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Box')], 1), _c('div', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v(" Kg ")])], 1)]), _c('div', {
    staticClass: "flex gap-4 mb-4"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.modal.length')) + " "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "placeholder": "0"
    },
    on: {
      "input": function input($event) {
        return _vm.handleDimensionInput('length', $event);
      }
    },
    model: {
      value: _vm.custom.length,
      callback: function callback($$v) {
        _vm.$set(_vm.custom, "length", $$v);
      },
      expression: "custom.length"
    }
  }), _c('div', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v(" cm ")])], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.modal.width')) + " "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "placeholder": "0"
    },
    on: {
      "input": function input($event) {
        return _vm.handleDimensionInput('width', $event);
      }
    },
    model: {
      value: _vm.custom.width,
      callback: function callback($$v) {
        _vm.$set(_vm.custom, "width", $$v);
      },
      expression: "custom.width"
    }
  }), _c('div', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v(" cm ")])], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.modal.height')) + " "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "placeholder": "0"
    },
    on: {
      "input": function input($event) {
        return _vm.handleDimensionInput('height', $event);
      }
    },
    model: {
      value: _vm.custom.height,
      callback: function callback($$v) {
        _vm.$set(_vm.custom, "height", $$v);
      },
      expression: "custom.height"
    }
  }), _c('div', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v(" cm ")])], 1)])]), _vm.custom.length > 0 && _vm.custom.width > 0 && _vm.custom.height > 0 ? _c('div', {
    staticClass: "p-3 bg-neutral-100 rounded-md border border-neutral-200 flex justify-between items-center"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500 font-medium"
  }, [_vm._v("Berat Volume")]), _c('p', {
    staticClass: "text-sm font-semibold text-neutral-600"
  }, [_vm._v(_vm._s(_vm.volumetricWeight) + " Kg")])]) : _vm._e()]), _vm.isPOD ? _c('div', {
    staticClass: "mb-6 flex items-center gap-4 w-full"
  }, [_c('div', {
    staticClass: "text-sm w-full p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700 rounded-md"
  }, [_c('Info', {
    attrs: {
      "width": "24",
      "height": "24",
      "color": "neutral-700"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('order.createOrder.stepOne.pod')) + " ")], 1)]) : _vm._e()])]), _c('div', {
    staticClass: "flex items-center p-6 justify-end bg-white gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.createOrder.stepOne.cancel'),
      "type": "secondary"
    },
    on: {
      "action": function action($event) {
        return _vm.cancelCreateOrder();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.createOrder.stepOne.next'),
      "disabled": _vm.isDisabled,
      "type": "primary"
    },
    on: {
      "action": function action($event) {
        return _vm.goToStep2();
      }
    }
  })], 1), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleAddressModal,
      "id": "address-form-modal",
      "overflowAuto": false
    },
    on: {
      "close": _vm.toggleAddressFormModal
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_vm.visibleAddressModal ? _c('AddressFormModal', {
    attrs: {
      "type": _vm.addressModalType,
      "initialData": _vm.addressModalInitialData
    },
    on: {
      "close": _vm.toggleAddressFormModal,
      "apply": _vm.handleAddressFormApply
    }
  }) : _vm._e()], 1)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }